import { render, staticRenderFns } from "./FaqScreen.vue?vue&type=template&id=381b1cd0&"
import script from "./FaqScreen.vue?vue&type=script&lang=js&"
export * from "./FaqScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports